import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import DocumentMeta from 'react-document-meta';
import * as authActions from 'redux/modules/auth';
import {getWindowSize} from '../../utils/utils';
import immutable from 'immutable';
import {TextInput, RxForm, Checkbox, FormField} from 'reactis-forms';

export default class AppLogin extends Component {

	componentWillMount() {
		$(document.body).addClass('login');
	}

	componentWillUnmount() {
		$(document.body).removeClass('login');
	}

	render() {
		return (
			<div className="page-container login-container" style={{height: getWindowSize().height * 0.9}}>
				<div className="page-content">
					<div className="content-wrapper">
						{this.props.children}
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/App/AppLogin.js